module.exports = __webpack_public_path__ + "static/media/carousel-gray-button.9f707475.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel-gray-button.svg
// module id = 873
// module chunks = 0